export enum ShowRoles {
  PROVISONAL_JUDGE = 'provisionalJudge',
  CREDENTIAL_JUDGE = 'credentialJudge',
  SHOW_STEWARDS = 'showSteward',
  MEDICAL_PERSONAL = 'medicalPersonnel',
  SHOW_SUPERVISOR = 'showSuperviser',
  OPTIONAL_PERSONAL = 'optionalPersonnel',
}
